'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024103 from "./presto.types$$anon$103.js";
import * as $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024 from "./presto.types$-Day-Of-Week-Utils$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
import * as $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload$0024 from "./presto.types$-Week-Day-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$102(outer) {
  this.c8Y = null;
  this.c8Q = null;
  this.c8R = false;
  this.c8Z = null;
  this.c90 = false;
  this.c93 = null;
  this.c8W = null;
  this.c8X = false;
  this.c8S = null;
  this.c8T = false;
  this.c8U = null;
  this.c8V = false;
  this.c91 = false;
  this.c92 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c8Y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c93 = "WeekDayPayload";
}
export { $c_Lpresto_types$Rule$$anon$102 as $c_Lpresto_types$Rule$$anon$102 };
$p = $c_Lpresto_types$Rule$$anon$102.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$102;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$102() {
}
export { $h_Lpresto_types$Rule$$anon$102 as $h_Lpresto_types$Rule$$anon$102 };
$h_Lpresto_types$Rule$$anon$102.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c8Y;
});
$p.M = (function() {
  if ((!this.c8R)) {
    this.c8Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c8R = true;
  }
  return this.c8Q;
});
$p.O = (function() {
  if ((!this.c90)) {
    this.c8Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c90 = true;
  }
  return this.c8Z;
});
$p.E = (function() {
  return this.c93;
});
$p.t = (function() {
  if ((!this.c8X)) {
    this.c8W = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("days", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c8X = true;
  }
  return this.c8W;
});
$p.N = (function() {
  if ((!this.c8T)) {
    this.c8S = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Sy(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024.$m_Lpresto_types$DayOfWeekUtils$().cH9())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c8T = true;
  }
  return this.c8S;
});
$p.Q = (function() {
  if ((!this.c8V)) {
    this.c8U = new $j_presto$002etypes$0024$0024anon$0024103.$c_Lpresto_types$$anon$103();
    this.c8V = true;
  }
  return this.c8U;
});
$p.v = (function() {
  if ((!this.c92)) {
    this.c91 = false;
    this.c92 = true;
  }
  return this.c91;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee159) => ((p) => \u03b4scrutinee159.cG7(p)))($j_presto$002etypes$0024$002dWeek$002dDay$002dPayload$0024.$m_Lpresto_types$WeekDayPayload$())));
});
var $d_Lpresto_types$Rule$$anon$102 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$102, "presto.types$Rule$$anon$102", ({
  a1w: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$102 as $d_Lpresto_types$Rule$$anon$102 };
//# sourceMappingURL=presto.types$-Rule$$anon$102.js.map
